import React from 'react';
import { lbl, inp, row2, DateInput } from './shared';

// Note: YesNo, MultiSelect, and income data moved to BenefitsIncome.js. Pharmacy moved to Pharmacy.js.
// Preferred Providers moved to Doctors.js (shown alongside doctors on the same page).

export default function Insurance({ data, onChange }) {
  return (
    <div>
      {/* Medicare fields */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 18 }}>
        <div>
          <label style={lbl}>Medicare Number</label>
          <input style={inp} value={data.medicareNumber} onChange={e => onChange('medicareNumber', e.target.value)} />
        </div>
        <div>
          <label style={lbl}>Part A Effective Date</label>
          <DateInput style={inp} value={data.partADate} onChange={v => onChange('partADate', v)} />
        </div>
        <div>
          <label style={lbl}>Part B Effective Date</label>
          <DateInput style={inp} value={data.partBDate} onChange={v => onChange('partBDate', v)} />
        </div>
      </div>

      <div style={row2}>
        <div>
          <label style={lbl}>Medicaid Number</label>
          <input style={inp} value={data.medicaidNumber} onChange={e => onChange('medicaidNumber', e.target.value)} />
        </div>
        <div>
          <label style={lbl}>Federal LIS</label>
          <input style={inp} value={data.federalLIS} onChange={e => onChange('federalLIS', e.target.value)} />
        </div>
      </div>
    </div>
  );
}
